import { post, get } from '../index';

export const checkoutSession = data => {
    return post('/stripe/checkout-session', data);
}

export const getProducts = data => {
    return get('/stripe/stripeproducts');
}

// $19 one-time pricing-catalog registration checkout (guest export flow)
export const catalogCheckoutSession = data => {
    return post('/stripe/catalog-checkout-session', data);
}

// Viewer status from CurLight: { viewer:'guest'|'member', masked, canExport }
export const getCatalogMemberStatus = () => {
    return get('/data/v2/member-status', true);
}